import { fd_url_manager as links } from '@grins/fd-modules/splits/onering-global';
import { Fandango_xhr as xhr } from '@grins/fd-modules/splits/onering-global';

function run() {
  xhr.init({ tokenURI: links.snapiGenerateCSRF() });
}
run();
